export default __webpack_public_path__ + "static/media/undraw_new_message_re_fp03.f6e78755.svg";